export default __webpack_public_path__ + "static/media/yas-island.24d560eb.webp";